var map = {
	"./javascript.jpg": 3511,
	"./photohead.png": 1738,
	"./photohead2.png": 1282,
	"./project1.png": 3434,
	"./project2.png": 4513,
	"./project3.png": 3384,
	"./project4.png": 5527,
	"./project5.png": 6030,
	"./project6.png": 3861,
	"./tefa.jpg": 156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3760;